import React, { FC } from 'react'

import { IconAttachmentProps } from './IconAttachment.types'
import * as Styled from './styles/IconAttachment.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAttachment: FC<IconAttachmentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAttachmentProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconAttachmentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M123.73 28.37a4 4 0 1 0-5.67-5.64L34.54 106.6a18.39 18.39 0 0 0 0 25.78 18.21 18.21 0 0 0 25.66 0L145 47.23a28 28 0 0 0 0-39.18 27.65 27.65 0 0 0-39.06 0L17.81 96.5a37.52 37.52 0 0 0 0 52.64 37.12 37.12 0 0 0 52.42 0l73.33-73.64a4 4 0 1 0-5.67-5.64l-73.31 73.62a29.1 29.1 0 0 1-41.09 0 29.49 29.49 0 0 1 0-41.36l88.05-88.42a19.64 19.64 0 0 1 27.73 0 19.93 19.93 0 0 1 0 27.91l-84.7 85.1a10.18 10.18 0 0 1-14.33 0 10.35 10.35 0 0 1 0-14.5z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconAttachment
